import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function MaintenanceModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Aviso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p align="center">⚠️ Sistema en Mantenimiento ⚠️ </p>
        <p align="justify">
          Estamos realizando tareas de mantenimiento. Por favor, intente más tarde.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
